import { render, staticRenderFns } from "./WrsViRadioGroup.vue?vue&type=template&id=bb269022&"
import script from "./WrsViRadioGroup.vue?vue&type=script&lang=js&"
export * from "./WrsViRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports